import { faCamera } from '@fortawesome/pro-duotone-svg-icons';
import { faGrinWink, faVideo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';

import { createSelectProductsPromptModalState } from '@/components/HabitatLink/utils';
import { useHabitatLiveStreamPlayerContext } from '@/components/HabitatLiveStreamPlayer/contexts';
import ZoomBar from '@/components/LiveStream/StreamInteractiveArea/StreamControls/ZoomBar';
import { useLiveStreamPlayerStateContext } from '@/components/LiveStreamPlayer/contexts';
import { setMembersOnlyWarningModalState } from '@/components/MembersOnlyWarningModal/redux/actions';
import { MembersOnlyWarningModalType } from '@/components/MembersOnlyWarningModal/redux/types';
import { setProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/actions';
import { useSelector, useStore } from '@/redux/helper';

import { MOBILE_CONTROLS_HEIGHT } from '../../../habitat/constants';

interface HomeLiveStreamPlayerFakeMobileControlsProps {
  modalType?: MembersOnlyWarningModalType | null;
}

const HomeLiveStreamPlayerFakeMobileControls = ({
  modalType = 'guest-general',
}: HomeLiveStreamPlayerFakeMobileControlsProps) => {
  const dispatch = useDispatch();
  const store = useStore();
  const { habitat } = useHabitatLiveStreamPlayerContext();
  const logged = useSelector((state) => state.user.logged);
  const { isPlaying } = useLiveStreamPlayerStateContext();
  if (!isPlaying) {
    return null;
  }
  const onClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (logged) {
      const defaultState = createSelectProductsPromptModalState(habitat._id)(store.getState());
      dispatch(
        setProductsPromptModalState({
          ...defaultState,
          entryPoint: 'home-player-fake-controls',
        }),
      );
    } else {
      dispatch(
        setMembersOnlyWarningModalState({
          type: modalType,
          redirectOnDismiss: false,
        }),
      );
    }
  };
  return (
    <div className="flex items-center gap-[10px] bg-primary-green" style={{ height: `${MOBILE_CONTROLS_HEIGHT}px` }}>
      <div className="flex items-center justify-center">
        <button type="button" onClick={onClick} className="preflight preflight-button size-10 text-white">
          <FontAwesomeIcon icon={faVideo} size="lg" />
        </button>
        <button type="button" onClick={onClick} className="preflight preflight-button size-10 text-white">
          <FontAwesomeIcon icon={faCamera} size="lg" />
        </button>
        <button type="button" onClick={onClick} className="preflight preflight-button size-10 text-white">
          <FontAwesomeIcon icon={faGrinWink} size="lg" />
        </button>
      </div>
      <button type="button" className="preflight preflight-button mr-[10px] grow" onClick={onClick}>
        <ZoomBar horizontal height="38px" className="!pointer-events-none" />
      </button>
    </div>
  );
};

export default HomeLiveStreamPlayerFakeMobileControls;
